export default __webpack_public_path__ + "static/media/formNameIcon.6e9628c5.svg";